import { ComponentDescriptor, UiDefaultValueDefinition } from 'app/infrastructure/ui/types-uischema';
import { deepEquals } from 'app/infrastructure/js';

/**
 * When adding a child, all default values must also be calculated and added.
 * The information about whether to add a default value is part of the component descriptors.
 */
export function resolveComponentDefaultValues
  (rootDescriptor: ComponentDescriptor): UiDefaultValueDefinition[] {

  const entityTypePathEquals = (descriptor: ComponentDescriptor) => {
    return deepEquals(descriptor.entityTypePath, rootDescriptor.entityTypePath);
  };

  const addDefaultValue = (descriptor: ComponentDescriptor, defaultValues: UiDefaultValueDefinition[]) => { 
    if (descriptor.defaultValue && entityTypePathEquals(descriptor)) {
      defaultValues.push({ dataTag: descriptor.dataTag, defaultValue: descriptor.defaultValue});
    }
  };
  
  // Get definitions recursively based on entityPath. Stop at children empty or domain iterate === true.
  const iterateChildren = (defaultValues: UiDefaultValueDefinition[], descriptor: ComponentDescriptor) => {
    if (!descriptor.iterate) {
      addDefaultValue(descriptor, defaultValues);
      
      descriptor.children && descriptor.children.map(child => iterateChildren(defaultValues, child));
    }

    return defaultValues;
  };

  return rootDescriptor.children && rootDescriptor.children.reduce(iterateChildren, []);
}
